import { api } from 'common';

import { InformationExtractionFormFields } from './FormFields';
import { informationExtractionDocumentationMarkdown } from './documentation';
import { getDefaultInformationExtractionConfig } from './utils';
import { type BlockConfigProps } from '../../types';

export const informationExtractionNodeConfig: BlockConfigProps<
  api.FlowDefinition.InformationExtractionBlock['config']
> = {
  defaultLabelPrefix: 'informationExtraction',
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultConfig: getDefaultInformationExtractionConfig(),
  configFields: {
    schema: api.FlowDefinition.InformationExtractionBlockConfigSchema,
    FormFields: InformationExtractionFormFields,
  },
  documentationMarkdown: informationExtractionDocumentationMarkdown,
};
